import { createActions, createReducer } from 'reduxsauce'

export const { Types: FinanceTypes, Creators } = createActions({
    getFinance: [],
    getFinanceSuccess: ['invoicesForClients', 'licenseFeesInvoices', 'summaries', 'invoicesWithMonthHeadings', 'invoicesByDates'],
    getFinanceFailure: ['getFinanceError'],
})

const INITIAL_STATE = {
    loadingFinance: false,
    invoicesForClients: [],
    licenseFeesInvoices: [],
    summaries: [],
    getFinanceError: null,
}

export const reducer = createReducer(INITIAL_STATE, {
    [FinanceTypes.GET_FINANCE]: state => ({
        ...state,
        loadingFinance: true,
    }),
    [FinanceTypes.GET_FINANCE_SUCCESS]: (
        state,
        { invoicesForClients, licenseFeesInvoices, summaries, invoicesWithMonthHeadings, invoicesByDates }
    ) => ({
        ...state,
        invoicesForClients,
        invoicesWithMonthHeadings,
        invoicesByDates,
        licenseFeesInvoices,
        summaries,
        loadingFinance: false,
        getFinanceError: null,
    }),
    [FinanceTypes.GET_FINANCE_FAILURE]: (state, { getFinanceError }) => ({
        ...state,
        loadingFinance: false,
        getFinanceError,
    }),
})

export default Creators
